import { forwardRef } from "react";

import { PanelLeft } from "lucide-react";

import { cn } from "../../../lib/utils";
import { Button } from "../../ui/button";
import { useSidebar } from "../../ui/sidebar";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../../ui/tooltip";

export const ToggleSidebarButton = forwardRef<
  HTMLButtonElement,
  ToggleSidebarButtonProps
>(({ className }, ref) => {
  const { state, toggleSidebar } = useSidebar();

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            ref={ref}
            variant="ghost"
            size="icon"
            className={cn(
              "p-1.5 hover:bg-gray-100 dark:hover:bg-white/10 text-neutral-500 dark:text-slate-300 transition-all duration-200 [&_svg]:size-4",
              className,
            )}
            aria-label="Toggle sidebar"
            onClick={toggleSidebar}
            data-testid="toggle-sidebar-button"
          >
            <PanelLeft />
          </Button>
        </TooltipTrigger>
        <TooltipContent side="right">
          <p>{state === "collapsed" ? "Expand sidebar" : "Collapse sidebar"}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
});

ToggleSidebarButton.displayName = "ToggleSidebarButton";

type ToggleSidebarButtonProps = {
  className?: string;
};
